import { kurentoClientManager } from './KurentoClientManager';

class KurentoConfig {
    #configurations = new Map();
    #iceServers;

    getWsUriByKurentoId(kurentoId) {
        const config = this.#configurations.get(kurentoId);
        if (!config) console.log(`getwsUriByKurentoId(): No config found for kurentoId=${kurentoId}, ${JSON.stringify([...this.#configurations])}`);
        return config?.wsUri || '';
    }

    getOptionsByKurentoId(kurentoId) {
        const config = this.#configurations.get(kurentoId);
        if (!config)
            console.log(`getOptionsByKurentoId(): No config found for kurentoId=${kurentoId},  ${JSON.stringify([...this.#configurations])}`);
        return config?.options || {};
    }

    getTestVideosByKurentoId(kurentoId) {
        const config = this.#configurations.get(kurentoId);
        if (!config)
            console.log(`getTestVideosByKurentoId(): No config found for kurentoId=${kurentoId},  ${JSON.stringify([...this.#configurations])}`);
        return config?.testVideos || [];
    }

    set configuration(configs) {
        configs.forEach(({ id, wsUri, options, testVideos, active }) => {
            this.#configurations.set(id, { wsUri, options, testVideos });
            kurentoClientManager.registerKurento(id, wsUri, active);
        });
        this.#iceServers = configs[0]?.options?.iceServers; // for direct media mtx
    }

    get iceServers() {
        return this.#iceServers;
    }

    removeConfig() {
        console.log('removeConfig(): Clearing kurento  configurations');
        this.#configurations.clear();
    }
}
export const kurentoConfig = new KurentoConfig();

if (import.meta.env.VITE_ENV !== 'production') window.kurentoConfig = kurentoConfig;
